import CryptoJS from 'crypto-js';
import Decimal from "decimal.js/decimal";
const Area = (p0, p1, p2) => {
  var area = 0.0;
  area = parseFloat(p0.longitude) * parseFloat(p1.latitude) +
    parseFloat(p1.longitude) * parseFloat(p2.latitude) +
    parseFloat(p2.longitude) * parseFloat(p0.latitude) -
    parseFloat(p1.longitude) * parseFloat(p0.latitude) -
    parseFloat(p2.longitude) * parseFloat(p1.latitude) -
    parseFloat(p0.longitude) * parseFloat(p2.latitude);
  return area / 2;
}

//amap 计算polygon的质心
export const getPolygonAreaCenter = (points) => {
  var sum_x = 0;
  var sum_y = 0;
  var sum_area = 0;
  var p1 = points[1];
  for (var i = 2; i < points.length; i++) {
    var p2 = points[i];
    var area = Area(points[0], p1, p2);
    sum_area += area;
    sum_x += (parseFloat(points[0].longitude) + parseFloat(p1.longitude) + parseFloat(p2.longitude)) * area;
    sum_y += (parseFloat(points[0].latitude) + parseFloat(p1.latitude) + parseFloat(p2.latitude)) * area;
    p1 = p2;
  }
  var xx = sum_x / sum_area / 3;
  var yy = sum_y / sum_area / 3;
  return {
    longitude: xx,
    latitude: yy
  };
}


export const formatSeconds = (value) => {
  var theTime = parseInt(value);// 需要转换的时间秒 
  var theTime1 = 0;// 分 
  var theTime2 = 0;// 小时 
  var theTime3 = 0;// 天
  if (theTime > 60) {
    theTime1 = parseInt(theTime / 60);
    theTime = parseInt(theTime % 60);
    if (theTime1 > 60) {
      theTime2 = parseInt(theTime1 / 60);
      theTime1 = parseInt(theTime1 % 60);
      if (theTime2 > 24) {
        //大于24小时
        theTime3 = parseInt(theTime2 / 24);
        theTime2 = parseInt(theTime2 % 24);
      }
    }
  }
  var result = '';
  if (theTime > 0) {
    result = "" + parseInt(theTime) + "秒";
  }
  if (theTime1 > 0) {
    result = "" + parseInt(theTime1) + "分" + result;
  }
  if (theTime2 > 0) {
    result = "" + parseInt(theTime2) + "小时" + result;
  }
  if (theTime3 > 0) {
    result = "" + parseInt(theTime3) + "天" + result;
  }
  return result;
}



export function base64ToFile(base64, fileName) {
  // 将base64按照 , 进行分割 将前缀  与后续内容分隔开
  let data = base64.split(',');
  // 利用正则表达式 从前缀中获取图片的类型信息（image/png、image/jpeg、image/webp等）
  let type = data[0].match(/:(.*?);/)[1];
  // 从图片的类型信息中 获取具体的文件格式后缀（png、jpeg、webp）
  let suffix = type.split('/')[1];
  // 使用atob()对base64数据进行解码  结果是一个文件数据流 以字符串的格式输出
  const bstr = window.atob(data[1]);
  // 获取解码结果字符串的长度
  let n = bstr.length
  // 根据解码结果字符串的长度创建一个等长的整形数字数组
  // 但在创建时 所有元素初始值都为 0
  const u8arr = new Uint8Array(n)
  // 将整形数组的每个元素填充为解码结果字符串对应位置字符的UTF-16 编码单元
  while (n--) {
    // charCodeAt()：获取给定索引处字符对应的 UTF-16 代码单元
    u8arr[n] = bstr.charCodeAt(n)
  }
  // 利用构造函数创建File文件对象
  // new File(bits, name, options)
  const file = new File([u8arr], `${fileName}.${suffix}`, {
    type: type
  })
  // 将File文件对象返回给方法的调用者
  return file;
}


export function replaceHttpsToHttp(url) {
  console.log('url: ', url);
  // 使用正则表达式将'https://'替换为'http://'
  if (url && url.indexOf('https://') === 0) {
    return url.replace(/^https:\/\//i, 'http://');
  }
}


export function isBase64(str) {
  // 去除字符串两端的空白字符
  str = str.trim();

  // 正则表达式匹配Base64编码格式
  const regex = /^[A-Za-z0-9+/]+={0,2}$/;

  // 使用正则表达式进行匹配
  return regex.test(str);
}




/**
 * 维吉尼亚密码实现。 人们在恺撒移位密码的基础上扩展出多表密码，称为维吉尼亚密码。 算法实现来自：https://github.com/zhaorenjie110/SymmetricEncryptionAndDecryption
 */

/**
 * 加密
 * @param data  数据
 * @param cipherKey 密钥
 */
export const encryptVigenere = (
  data,
  cipherKey = 'kf-library',
) => {
  const dataLen = data.length;
  const cipherKeyLen = cipherKey.length;
  if (dataLen === 0 || cipherKeyLen === 0) {
    return '';
  } else {
    const cipherArray = [];
    for (let i = 0; i < dataLen / cipherKeyLen + 1; i++) {
      for (let t = 0; t < cipherKeyLen; t++) {
        if (t + i * cipherKeyLen < dataLen) {
          const dataChar = data.charCodeAt(t + i * cipherKeyLen);
          const cipherKeyChar = cipherKey.charCodeAt(t);
          cipherArray[t + i * cipherKeyLen] =
            ((dataChar + cipherKeyChar - 64) % 95) + 32;
        }
      }
    }
    return String.fromCharCode(...cipherArray);
  }
};

/**
* 解密
* @param data  数据
* @param cipherKey 密钥
*/
export const decryptVigenere = (
  data,
  cipherKey = 'kf-library',
) => {
  const dataLen = data.length;
  const cipherKeyLen = cipherKey.length;
  if (dataLen === 0 || cipherKeyLen === 0) {
    return '';
  } else {
    const clearArray = [];
    for (let i = 0; i < dataLen; i++) {
      for (let t = 0; t < cipherKeyLen; t++) {
        if (t + i * cipherKeyLen < dataLen) {
          const dataChar = data.charCodeAt(t + i * cipherKeyLen);
          const cipherKeyChar = cipherKey.charCodeAt(t);
          if (dataChar - cipherKeyChar >= 0) {
            clearArray[t + i * cipherKeyLen] =
              ((dataChar - cipherKeyChar) % 95) + 32;
          } else {
            clearArray[t + i * cipherKeyLen] =
              ((dataChar - cipherKeyChar + 95) % 95) + 32;
          }
        }
      }
    }
    return String.fromCharCode(...clearArray);
  }
};

